export { default } from './CapcaleraTemps';
